module.exports = __webpack_public_path__ + "img/4.99b6cc90.jpg";